import { Paper, Box } from "@mui/material";
import { createContext, useCallback, useContext, useState, useEffect } from "react";
import { HeaderBar } from "../utils/HeaderBar";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const TableLayout = ({ title, component: Component }) => {
  const FILTER_DRAWER_WIDTH = 260; // inline ✅

const isFilterOpen = useSelector(
  (state) => state.filterDrawer?.open
);
  const { state, pathname } = useLocation()
  const [filters, setFilters] = useState({
    exceptions: state?.exceptions ? state.exceptions.map(item => ({ detailName: item.label, count: item.value, isActive: true })) : [],
    states: state?.states ? state.states.map(item => ({ detailName: item.label, count: item.value, isActive: true })) : [],
    search: {},
    columnFilters: null, // AG Grid column-level filters
  });

  // Reset columnFilters when route changes
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      columnFilters: null,
    }));
  }, [pathname]);

  const [headerFilters, setHeaderFilters] = useState({
    exceptions: state?.exceptions ? state.exceptions.map(item => ({ detailName: item.label, count: item.value, isActive: true })) : [],
    states: state?.states ? state.states.map(item => ({ detailName: item.label, count: item.value, isActive: true })) : [],
  })

  const [orderType, setOrderType] = useState("standardPO");
  const [rowCount, setRowCount] = useState(0);

  const onEmit = (value) => setFilters((prev) => ({ ...prev, search: value }));

  const onFilterSelect = useCallback((updatedFilter) => {
    if (headerFilters?.exceptions?.some(val => updatedFilter.selectedExceptions.some(value => value !== val)) ||
      headerFilters?.states?.some(val => updatedFilter.selectedStates.some(value => value !== val)))
      return;
    setFilters((prev) => ({
      ...prev,
      exceptions: updatedFilter.selectedExceptions || [],
      states: updatedFilter.selectedStates || [],
    }));
    setHeaderFilters(null)
  }, [headerFilters]);

  const onOrderTypeChange = useCallback((newOrderType) => {
    setOrderType(newOrderType);
  }, []);

  // Handle AG Grid column-level filter changes
  const onColumnFilterChanged = useCallback((columnFilters) => {
    
    setFilters((prev) => ({
      ...prev,
      columnFilters: Object.keys(columnFilters).length > 0 ? columnFilters : null,
    }));
  }, []);

  return (
    <RowCountProvider>
      {/* ✅ THIS IS THE MAGIC CONTAINER */}
      <Box
        sx={{
          marginLeft: isFilterOpen ? `${FILTER_DRAWER_WIDTH}px` : 0,
          transition: "margin-left 0.3s ease",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#A6C0C4",
            padding: 1.5,
            borderRadius: 1,
          }}
        >
          <Paper elevation={3} sx={{ padding: 1, marginBottom: 2 }}>
            <HeaderBar
              title={title}
              count={rowCount}
              onSearch={onEmit}
              onFilterSelect={onFilterSelect}
              orderType={orderType}
              onOrderTypeChange={onOrderTypeChange}
              {...headerFilters}
            />
          </Paper>

          <Paper
            elevation={2}
            sx={{
              padding: 0,
              width: "100%",
              boxShadow: "none",
              backgroundColor: "white",
              marginRight: 1,
            }}
          >
            <Component
              filters={filters}
              setRowCount={setRowCount}
              orderType={orderType}
              onColumnFilterChanged={onColumnFilterChanged}
            />
          </Paper>
        </Box>
      </Box>
    </RowCountProvider>
  );
};

export default TableLayout;


export const RowCountContext = createContext({
  rowCount: 0,
  setRowCount: () => { },
});

export function useRowCount() {
  return useContext(RowCountContext);
}

export function RowCountProvider({ children }) {
  const [rowCount, setRowCount] = useState(0);
  const updateRowCount = useCallback((count) => setRowCount(count), []);
  return (
    <RowCountContext.Provider value={ { rowCount, setRowCount: updateRowCount } }>
      { children }
    </RowCountContext.Provider>
  );
}
